import { NgModule } from "@angular/core";
import { materialModuleImports } from "app/shared/modules/material/material.module.imports";
@NgModule({
  imports: [...materialModuleImports],
  exports: [...materialModuleImports]
})
export class MaterialModule {}
